import React, { useState, useEffect } from "react";
import "./App.css";
import Todo from "./Todo";
import db from "./firebase";
import {Button,FormControl, Input ,InputLabel } from '@material-ui/core';
import firebase from "firebase";

function App() {
  const [input, setInput] = useState("");
  const [todos, setTodos] = useState([]);

  useEffect(() => {
    console.log("I ran when the component loaded");

    db.collection("todos").orderBy('timestamp','desc').onSnapshot((snapshot) => {
      setTodos(snapshot.docs.map(doc => ({id: doc.id, todo:doc.data().todo})))
    });
  }, []);

  const addTodo = (e) => {
    e.preventDefault();
    db.collection("todos").add({
      todo: input,
      timestamp: firebase.firestore.FieldValue.serverTimestamp()
    });

    setInput("");
  };

  return (
    <div className="App">
      <h1>😍Raviprakash Todo App😍</h1>

      <form>
        <FormControl>
          <InputLabel>📋 Write a Todo ✍️ </InputLabel>
          <Input value={input} onChange={event => setInput(event.target.value)} />
        </FormControl>

        <Button disabled={!input} type="submit" onClick={addTodo} variant="contained" color="primary">
          Add todo
        </Button>
      </form>

    <ul>
      {todos.map((todo, i) => (
        <Todo todo={todo} key={i} />
      ))}
      </ul>
    </div>
  );
}

export default App;


